import { createSlice } from "@reduxjs/toolkit";
import { API_URL } from "../api";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    // defaultEmail: "kwin@gmail.com",
    // defaultPassword: "root123",
    settingEmail: "",
    settingPassword: "",
    login: false,
    user: "",
    email: "",
    password: "",
    LoginURL: API_URL(),
  },
  reducers: {
    loginSuccess: (state) => {
      state.login = true;
    },
    addUser: (state, action) => {
      console.log(action.payload);
      state.user = action.payload;
    },
    setSettingCredentials: (state, action) => {
      // state.defaultEmail = "kwin@gmail.com";
      // state.defaultPassword = "root123";
      state.settingEmail = action.payload.email;
      state.settingPassword = action.payload.password;
    },
    superAdminLogout: (state) => {
      state.settingEmail = "";
      state.settingPassword = "";
    },
    logoutSuccess: (state) => {
      state.login = false;
      state.user = "";
      state.email = "";
      state.password = "";
    },
  },
});

export const {
  loginSuccess,
  addUser,
  setSettingCredentials,
  superAdminLogout,
  logoutSuccess,
} = authSlice.actions;
export default authSlice.reducer;
